const removeNodeFromList = (state, listName, id) => {
  const list = state[listName]
  const { nodes, edges, totalCount } = list
  const found = nodes.indexOf(id) > -1

  const newList = {
    ...list,
    nodes: nodes.filter(nodeId => nodeId !== id),
    edges: edges.filter(edge => edge.node.id !== id),
    totalCount: found ? totalCount - 1 : totalCount,
  }

  return {
    ...state,
    [listName]: newList,
  }
}

export default function makeRemoveOnGraphQLAction(listMatcher, actionType) {
  return function(state, { type, payload, metadata }) {
    if (type !== actionType) {
      return state
    }

    const nodes = Array.isArray(payload) ? payload : [payload]

    return Object.keys(state).reduce((state, listName) => {
      return nodes.reduce((state, node) => {
        if (listMatcher(listName, state[listName], node, type)) {
          return removeNodeFromList(state, listName, node.id)
        }
        return state
      }, state)
    }, state)
  }
}
